/**
 * PostNL-style delivery estimate for NL storefronts.
 * Uses Europe/Amsterdam (CET/CEST). Per-day labels and cutoffs come from
 * Theme settings → Delivery label; otherwise falls back to cutoff 18:00,
 * no delivery Sun/Mon.
 */
(function () {
  var TZ = "Europe/Amsterdam";
  var CUTOFF_MINUTES = 18 * 60;
  var DAYS_NL = [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ];

  function getCutoffCalendar(now) {
    var d = now || new Date();
    var datePart = new Intl.DateTimeFormat("sv-SE", {
      timeZone: TZ,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(d);
    var parts = datePart.split("-").map(Number);
    var y = parts[0];
    var m = parts[1];
    var day = parts[2];

    var timePart = new Intl.DateTimeFormat("en-GB", {
      timeZone: TZ,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(d);
    var hm = timePart.split(":").map(Number);
    var minutes = hm[0] * 60 + hm[1];
    var beforeCutoff = minutes < CUTOFF_MINUTES;

    var wdShort = new Intl.DateTimeFormat("en-US", {
      timeZone: TZ,
      weekday: "short",
    }).format(d);
    var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var dow = map[wdShort];

    return {
      y: y,
      m: m,
      d: day,
      dow: dow,
      minutes: minutes,
      beforeCutoff: beforeCutoff,
    };
  }

  /** Parses "HH:MM" (or "HH.MM" / "HH") to minutes since midnight, or null. */
  function parseCutoff(value) {
    var match = String(value || "")
      .trim()
      .match(/^(\d{1,2})(?:[:.](\d{2}))?$/);
    if (!match) return null;
    var hours = Number(match[1]);
    var mins = Number(match[2] || 0);
    if (hours > 24 || mins > 59) return null;
    return hours * 60 + mins;
  }

  /** Label from theme settings (Theme settings → Delivery label), or null. */
  function customLabel(cal) {
    var schedule = (window.themeDeliveryEstimate || {}).schedule;
    if (!Array.isArray(schedule)) return null;
    var day = schedule[cal.dow];
    if (!day) return null;

    var before = String(day.before || "").trim();
    var after = String(day.after || "").trim();
    var cutoff = parseCutoff(day.cutoff);
    var isBefore = cutoff === null || cal.minutes < cutoff;
    var label = isBefore ? before || after : after || before;
    return label || null;
  }

  function addCalendarDays(y, m, d, add) {
    var t = Date.UTC(y, m - 1, d + add);
    var dt = new Date(t);
    return {
      y: dt.getUTCFullYear(),
      m: dt.getUTCMonth() + 1,
      d: dt.getUTCDate(),
    };
  }

  function sameYMD(a, b) {
    return a.y === b.y && a.m === b.m && a.d === b.d;
  }

  function weekdayIndexUTC(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d, 12, 0, 0)).getUTCDay();
  }

  /** @returns {number} calendar days from order day until delivery day */
  function deliveryOffsetDays(dow, beforeCutoff) {
    if (dow === 6) return 3;
    if (dow === 0) return 2;
    if (dow === 5) return beforeCutoff ? 1 : 4;
    return beforeCutoff ? 1 : 2;
  }

  function getStrings() {
    var t = window.themeDeliveryEstimate || {};
    return {
      tomorrow: t.tomorrow || "Morgen bezorgd",
      onDay: t.onDay || "Bezorgd op __DAY__",
    };
  }

  function formatLabel() {
    var cal = getCutoffCalendar();
    var custom = customLabel(cal);
    if (custom) return custom;

    var off = deliveryOffsetDays(cal.dow, cal.beforeCutoff);
    var delivery = addCalendarDays(cal.y, cal.m, cal.d, off);
    var tomorrow = addCalendarDays(cal.y, cal.m, cal.d, 1);
    var str = getStrings();

    if (sameYMD(delivery, tomorrow)) {
      return str.tomorrow;
    }
    var w = weekdayIndexUTC(delivery.y, delivery.m, delivery.d);
    var name = DAYS_NL[w];
    return str.onDay.replace(/__DAY__/g, name);
  }

  function updateElement(el, label) {
    if (!el) return;
    el.textContent = label;
  }

  function updateAll() {
    var label = formatLabel();
    document
      .querySelectorAll("[data-delivery-estimate]")
      .forEach(function (el) {
        updateElement(el, label);
      });
  }

  function setupObserver() {
    if (!("MutationObserver" in window)) return;
    var root = document.body || document.documentElement;
    if (!root) return;

    var observer = new MutationObserver(function (mutations) {
      var label = formatLabel();

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (node.matches && node.matches("[data-delivery-estimate]")) {
            updateElement(node, label);
          }

          if (node.querySelectorAll) {
            node
              .querySelectorAll("[data-delivery-estimate]")
              .forEach(function (el) {
                updateElement(el, label);
              });
          }
        });
      });
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", updateAll);
  document.addEventListener("DOMContentLoaded", setupObserver);
  document.addEventListener("delivery-estimate:update", updateAll);
  document.addEventListener("shopify:section:load", updateAll);

  window.getPostNLDeliveryEstimateLabel = formatLabel;
  window.updateDeliveryEstimates = updateAll;
})();
